/**CORE LIBRARIES IMPORT */
import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaCheckCircle, FaIndustry, FaShippingFast, FaAward, FaHeadset, FaShieldAlt } from "react-icons/fa";

/**COMPONENTS IMPORT */
import Products from "../Components/Products";
import Information from "../Components/Information";

const Home = () => {
  return (
    <>  
      {/* HERO SECTION */}
      <section className="hero-section">
        <div className="hero-wrapper">
          <motion.div
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <motion.span
              className="hero-badge"
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.5 }}
            >
              ★ Trusted Metal Manufacturer &amp; Supplier In India
            </motion.span>

            <motion.h1
              className="hero-title"
              initial={{ opacity: 0, y: 25 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.7 }}
            >
              JK Metal &amp; Alloys — Premium Tin, Lead, Solder &amp; Copper Products
            </motion.h1>

            <motion.p
              className="hero-description"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.6 }}
            >
              We manufacture and supply high-purity Tin Ingots, Lead Ingots, Solder Wires, Solder Sticks (63/37), Copper Axe &amp; Round Bars for electronics, electrical, automotive, and industrial joining applications across India.
            </motion.p>

            <motion.div 
              className="hero-actions"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.6 }}
            >
              <Link to="/products" className="btn-primary">
                Explore Products Catalog
              </Link>
              <Link to="/product-enquiry" className="btn-secondary">
                Request Quick Quote
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* HIGHLIGHT STATS BAR */}
      <section className="stats-bar-section">
        <div className="stats-container">
          <div className="stat-card">
            <span className="stat-number">99.9%</span>
            <span className="stat-label">High-Purity Alloy Standard</span>
          </div>
          <div className="stat-card">
            <span className="stat-number">PAN India</span>
            <span className="stat-label">Fast &amp; Reliable Delivery</span>
          </div>
          <div className="stat-card">
            <span className="stat-number">Est. 2019</span>
            <span className="stat-label">Ahmedabad Manufacturing Unit</span>
          </div>
          <div className="stat-card">
            <span className="stat-number">100%</span>
            <span className="stat-label">Quality Inspection Guarantee</span>
          </div>
        </div>
      </section>

      {/* ABOUT JK METAL SECTION */}
      <Information 
        subtitle="Premier Metal Manufacturer & Supplier"
        title="Welcome to JK Metal & Alloys"
        description="Founded in 2019 and headquartered in Ahmedabad, Gujarat, JK Metal & Alloys is a recognized manufacturer and supplier of non-ferrous metal ingots, soldering alloys, and copper products. We serve diverse industries including electronics assembly, electrical transformers, automotive components, and industrial manufacturing. Backed by rigorous quality control, modern smelting methods, and pan-India logistics, we ensure every ingot and solder wire meets exact chemical purity benchmarks."
        bullets={[
          { title: "High-Purity Manufacturing", text: "Strict chemical composition verification and zero-impurity refine process." },
          { title: "Pan-India Logistics", text: "Reliable delivery network serving clients across all major Indian states." },
          { title: "Custom Alloy Ratios", text: "Solder sticks & ingots customized to client-specified melting points and tin-lead ratios." }
        ]}
        imageType="tin"
        category="About Company"
        showGradient={true}
      />

      {/* PRODUCTS CATALOG SECTION */}
      <Products />

      {/* WHY CHOOSE US SECTION */}
      <section className="why-choose-section">
        <div className="why-choose-container">
          <div className="section-header center">
            <span className="sub-title">Why Partner With Us</span>
            <h2 className="section-heading">The JK Metal &amp; Alloys Advantage</h2>
            <p className="section-desc">Delivering excellence in non-ferrous metallurgy with precision and trust.</p>
          </div>

          <div className="why-cards-grid">
            <div className="why-card">
              <div className="why-icon"><FaAward /></div>
              <h3>ISO Quality Standards</h3>
              <p>Every batch of Tin Ingots, Lead Ingots, and Solder Wire undergoes strict metallurgical laboratory verification for chemical purity.</p>
            </div>

            <div className="why-card">
              <div className="why-icon"><FaIndustry /></div>
              <h3>Modern Smelting Unit</h3>
              <p>State-of-the-art foundry equipment in Ahmedabad, Gujarat, allowing high capacity production and consistent alloy composition.</p>
            </div>

            <div className="why-card">
              <div className="why-icon"><FaShippingFast /></div>
              <h3>PAN-India Delivery</h3>
              <p>Efficient supply chain management ensuring fast dispatch for both small orders and bulk industrial contract shipments.</p>
            </div>

            <div className="why-card">
              <div className="why-icon"><FaShieldAlt /></div>
              <h3>Custom Formulations</h3>
              <p>We tailor Tin-Lead ratios (63/37, 60/40, 50/50), solder stick lengths, and ingot dimensions to match specific customer needs.</p>
            </div>
          </div>
        </div>
      </section>

      {/* QUICK INQUIRY BANNER */}
      <section className="cta-banner-section">
        <div className="cta-banner-container">
          <h2>Need Bulk Supply of Tin, Lead, or Solder Products?</h2>
          <p>Get in touch with our expert sales team for current market pricing, technical datasheets, and custom alloy solutions.</p>
          <div className="cta-btn-group">
            <a href="tel:+918511698600" className="btn-light"><FaHeadset style={{ marginRight: '8px' }} /> Call +91 85116 98600</a>
            <Link to="/product-enquiry" className="btn-gold">Request Product Quotation</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;